exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#JDS-ThemeButton {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  opacity: 0.7;\n  z-index: 20;\n}\n#JDS-ThemeButton:hover {\n  opacity: 1;\n}\n#JDS-ThemeButton .svgIcon {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  cursor: pointer;\n  fill: var(--button-outlineActive);\n}\n", ""]);

